<template lang="pug">
section.contract(v-if="isSuperUser")
    .switches.cms
        el-switch(
            :active-text="$t('CMS')"
            :disabled="true"
            v-model="cms"
        )
        el-switch(
            v-if="extensionAvailable('forms')"
            :active-text="$t('Forms')"
            v-model="forms"
        )
        el-switch(
            v-if="extensionAvailable('maps')"
            :active-text="$t('Maps')"
            v-model="maps"
        )
        el-switch(
            v-if="extensionAvailable('restricted-area')"
            :active-text="$t('Restricted areas')"
            v-model="restrictedArea"
        )
        el-switch(
            v-if="extensionAvailable('event-manager')"
            :active-text="$t('Event manager')"
            v-model="eventManager"
        )
        el-switch(
            v-if="extensionAvailable('marketing')"
            :active-text="$t('Marketing')"
            v-model="marketing"
        )
        el-switch(
            :active-text="$t('Status Logs')"
            v-model="statusLogs"
        )
    .switches.shop(v-if="extensionAvailable('shop')")
        el-switch(
            v-if="extensionAvailable('shop')"
            :active-text="$t('Shop')"
            v-model="shop"
        )
        el-switch(
            v-if="extensionAvailable('shop') && extensionAvailable('shop:point-of-sale')"
            :disabled="shop !== true"
            :active-text="$t('Point of sale')"
            v-model="pos"
        )

    el-row.no-margin(:gutter="20")
        el-col(:sm="10")
            .flex-row
                el-form-item.grow(:label="$t('Contract nr.')" prop="nr")
                    el-input(v-model="nr" maxlength="255" show-word-limit)
                el-form-item(:label="$t('Billing period')")
                    el-select.is-full-width(
                        v-model="billingPeriod"
                        clearable
                        placeholder=""
                    )
                        component(
                            v-for="item in options.billingPeriod.items"
                            :key="item.key"
                            :value="item.key"
                            :label="$t(item.label)"
                            :is="item.el"
                        )
                            template(v-if="item.options && item.options.length")
                                el-option(
                                    v-for="option in item.options"
                                    :key="option.key"
                                    :value="option.key"
                                    :label="$t(option.label)"
                                )
                el-form-item(:label="$t('Status')")
                    el-select.is-full-width(
                        v-model="status"
                        placeholder=""
                    )
                        el-option(
                            v-for="item in options.status.items"
                            :key="item.value"
                            :label="$t(item.label)"
                            :value="item.value"
                        )
            .flex-row
                el-form-item.grow(:label="$t('Hosting fee')")
                    el-input(type="number" v-model="hostingFee" step="0.01" min="0")
                        template(slot="append")
                            i.el-icon-fa-euro-sign.fas
                el-form-item.grow(:label="$t('Service fee')")
                    el-input(type="number" v-model="serviceFee" step="0.01" min="0")
                        template(slot="append")
                            i.el-icon-fa-euro-sign.fas
                el-form-item.grow(:label="$t('Sum')")
                    el-input(type="number" :value="fee" disabled step="0.01" min="0")
                        template(slot="append")
                            i.el-icon-fa-euro-sign.fas
            .flex-row
                el-form-item.grow(:label="$t('Contract beginning')")
                    el-date-picker.is-full-width(
                        v-model="contractBeginning"
                        type="date"
                        :format="$t('yyyy-MM-dd')"
                        prefix-icon="far el-icon-fa-calendar-alt"
                        :picker-options="{ firstDayOfWeek: 1, disabledDate: disabledContractBeginningDate }"
                    )
                el-form-item.grow(:label="$t('Contract end')")
                    el-date-picker.is-full-width(
                        v-model="contractEnd"
                        type="date"
                        :format="$t('yyyy-MM-dd')"
                        prefix-icon="far el-icon-fa-calendar-alt"
                        :picker-options="{ firstDayOfWeek: 1, disabledDate: disabledContractEndDate }"
                    )

            .address(v-if="data.billingAddress" )
                el-form-item.less-margin(:label="$t('Billing Address')")
                .flex-row
                    el-form-item.grow(:label="$t('Company')")
                        el-input(v-model="company")
                    el-form-item(:label="$t('Company Addition')")
                        el-input(v-model="companyAddition")
                el-row.no-padding(:gutter="20")
                    el-col(:lg="6" :md="6")
                        el-form-item(:label="$t('Salutation')")
                            el-select.is-full-width(placeholder="" v-model="gender")
                                el-option(:label="$t('Mr.')" value="M")
                                el-option(:label="$t('Mrs.')" value="F")
                                el-option(:label="$t('Undefined')" value="X")
                    el-col(:lg="9" :md="9")
                        el-form-item(:label="$t('First name')")
                            el-input(v-model="firstName" maxlength="255" show-word-limit)
                    el-col(:lg="9" :md="9")
                        el-form-item(:label="$t('Last name')")
                            el-input(v-model="lastName" maxlength="255" show-word-limit)
                el-form-item(:label="$t('Street')")
                    el-input(v-model="street" maxlength="255" show-word-limit)
                el-row.no-padding(:gutter="20")
                    el-col(:lg="8" :md="8")
                        el-form-item(:label="$t('Zipcode')")
                            el-input(v-model="zipcode" maxlength="255" show-word-limit)
                    el-col(:lg="16" :md="16")
                        el-form-item(:label="$t('City')")
                            el-input(v-model="city" maxlength="255" show-word-limit)
                el-form-item(:label="$t('Country')")
                    el-select.is-full-width(placeholder="" filterable v-model="country" autocomplete="no-fill")
                        el-option(v-for="(label, value) in countries" :key="value" :label="label" :value="value")
            el-form-item.no-margin(v-else :label="$t('Billing Address')")
                .panel
                    .flex-row
                        .info.grow
                            .name(v-if="data.address && data.address.name") {{ data.address.name }}
                            .name(v-else-if="data.owner && data.owner.user && data.owner.user.name") {{ data.owner.user.name }}
                            .address-one-liner(v-if="data.address && data.address.oneLiner") {{ data.address.oneLiner }}
                        .actions
                            el-button(
                                plain
                                circle
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-pencil-alt fas"
                                @click="addBillingAddress"
                            )
        el-col(:sm="14")
            el-form-item.no-margin(:label="$t('Billing text')")
                quill-editor(v-model="billingText" :options="quillConfig")
</template>

<i18n>
{
    "de": {
        "Contract nr.": "Vertragsnummer",
        "Draft": "Entwurf",
        "Pro Bono": "Pro Bono",
        "Bundle": "Paket",
        "Billing": "Abrechnen",
        "Terminated": "Gekündigt",
        "Hosting fee": "Hostinggebühr netto",
        "Service fee": "Servicegebühr netto",
        "Sum": "Summe",
        "Billing period": "Abrechnungszeitraum",
        "monthly": "Monatlich",
        "quarterly": "Quartalsweise",
        "1. Quartal": "1. Quartal",
        "2. Quartal": "2. Quartal",
        "3. Quartal": "3. Quartal",
        "4. Quartal": "4. Quartal",
        "annually": "Jährlich",
        "January": "Januar",
        "February": "Februar",
        "March": "März",
        "April": "April",
        "May": "Mai",
        "June": "Juni",
        "July": "Juli",
        "August": "August",
        "September": "September",
        "October": "Oktober",
        "November": "November",
        "December": "Dezember",
        "Billing text": "Abrechnungstext",
        "Contract beginning": "Vertragsbeginn",
        "Contract end": "Vertragsende",
        "Shop": "Shop",
        "Point of sale": "Kasse",
        "Forms": "Formulare",
        "Status Logs": "Status Berichte",
        "Event manager": "Event Verwaltung",
        "Restricted areas": "Interner Bereich",
        "Billing Address": "Rechnungsadresse",
        "Street": "Straße",
        "Zipcode": "PLZ",
        "City": "Ort",
        "Country": "Land",
        "Company": "Firma",
        "Company Addition": "Firmenzusatz",
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { startOfDay, endOfDay, compareAsc, compareDesc, addDays, getUnixTime, fromUnixTime } from 'date-fns';

import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import de from 'i18n-iso-countries/langs/de.json'

countries.registerLocale(en)
countries.registerLocale(de)

import store from '@/store'
import quillConfig from '@/quill/config';

export default {
    name: 'AbonementrContract',
    data() {
        return {
            quillConfig,
        };
    },
    computed: {
        nr: {
            get() {
                return _.get(this.data, 'nr', '')
            },
            set(value) {
                store.commit(`settings/form/nr`, value)
            }
        },
        status: {
            get() {
                return _.get(this.data, 'status', '')
            },
            set(value) {
                store.commit(`settings/form/status`, value)
            }
        },
        hostingFee: {
            get() {
                return _.get(this.data, 'hosting_fee', '')
            },
            set(value) {
                if (value !== '') value = parseFloat(value)
                store.commit(`settings/form/hostingFee`, value)
            }
        },
        serviceFee: {
            get() {
                return _.get(this.data, 'service_fee', '')
            },
            set(value) {
                if (value !== '') value = parseFloat(value)
                store.commit(`settings/form/serviceFee`, value)
            }
        },
        fee() {
            if (!this.hostingFee && !this.serviceFee) return undefined
            return this.hostingFee + this.serviceFee
        },
        billingText: {
            get() {
                return _.get(this.data, 'billing_text', '')
            },
            set(value) {
                store.commit(`settings/form/billingText`, value)
            }
        },
        billingPeriod: {
            get() {
                return _.get(this.data, 'billing_period', '')
            },
            set(value) {
                store.commit(`settings/form/billingPeriod`, value)
            }
        },
        contractBeginning: {
            get() {
                let timestamp = _.get(this.data, 'contract_beginning');
                return timestamp != null ? startOfDay(fromUnixTime(timestamp)) : '';
            },
            set(value) {
                const timestamp = value != null ? getUnixTime(value) : null;
                store.commit(`settings/form/contractBeginning`, timestamp)
            }
        },
        contractEnd: {
            get() {
                let timestamp = _.get(this.data, 'contract_end');
                return timestamp != null ? endOfDay(fromUnixTime(timestamp)) : '';
            },
            set(value) {
                const timestamp = value != null ? getUnixTime(value) : null;
                store.commit(`settings/form/contractEnd`, timestamp)
            }
        },
        cms: {
            get() {
                return true
            },
            set() {
                // TODO
            }
        },
        shop: {
            get() {
                // return !! _.get(this.data, 'shop') && _.get(this.data, 'shop.deleted') !== true

                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'shop')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/createShop`)
                    store.commit(`settings/form/addExtension`, { key: 'shop' })
                } else {
                    // store.commit(`account/form/administrator/deleteShop`, this.index)
                    store.commit(`settings/form/removeExtension`, { key: 'shop' })
                }
            }
        },
        pos: {
            get() {
                // return !! _.get(this.data, 'shop') && _.get(this.data, 'shop.deleted') !== true

                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'shop')
                    && !!extensions.find(extension => extension.key === 'shop:point-of-sale')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'shop:point-of-sale' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'shop:point-of-sale' })
                }
            }
        },
        eventManager: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'event-manager')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'event-manager' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'event-manager' })
                }
            }
        },
        restrictedArea: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'restricted-area')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'restricted-area' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'restricted-area' })
                }
            }
        },
        forms: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'forms')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'forms' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'forms' })
                }
            }
        },
        maps: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'maps')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'maps' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'maps' })
                }
            }
        },
        marketing: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'marketing')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'marketing' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'marketing' })
                }
            }
        },
        statusLogs: {
            get() {
                const extensions = this.data.extensions || []
                return !!extensions.find(extension => extension.key === 'status-logs')
            },
            set(value) {
                if (value === true) {
                    store.commit(`settings/form/addExtension`, { key: 'status-logs' })
                } else {
                    store.commit(`settings/form/removeExtension`, { key: 'status-logs' })
                }
            }
        },

        gender: {
            get() {
                return _.get(this.data, 'billingAddress.gender', '');
            },
            set: value => store.commit('settings/form/billingAddress/gender', value)
        },
        firstName: {
            get() {
                return _.get(this.data, 'billingAddress.first_name', '');
            },
            set: value => store.commit('settings/form/billingAddress/firstName', value)
        },
        lastName: {
            get() {
                return _.get(this.data, 'billingAddress.last_name', '');
            },
            set: value => store.commit('settings/form/billingAddress/lastName', value)
        },
        company: {
            get() {
                return _.get(this.data, 'billingAddress.company', '');
            },
            set: value => store.commit('settings/form/billingAddress/company', value)
        },
        companyAddition: {
            get() {
                return _.get(this.data, 'billingAddress.company_addition', '');
            },
            set: value => store.commit('settings/form/billingAddress/companyAddition', value)
        },
        street: {
            get() {
                return _.get(this.data, 'billingAddress.street', '');
            },
            set: value => store.commit('settings/form/billingAddress/street', value)
        },
        zipcode: {
            get() {
            return _.get(this.data, 'billingAddress.zipcode', '');
            },
            set: value => store.commit('settings/form/billingAddress/zipcode', value)
        },
        city: {
            get() {
            return _.get(this.data, 'billingAddress.city', '');
            },
            set: value => store.commit('settings/form/billingAddress/city', value)
        },
        country: {
            get() {
            return _.get(this.data, 'billingAddress.country', '');
            },
            set: value => store.commit('settings/form/billingAddress/country', value)
        },

        countries() {
            return countries.getNames('de')
        },
        disabledContractBeginningDate(start) {
            const end = this.contractEnd;
            if (end) return compareAsc(addDays(start, 1), end) > 0;
            else return false;
        },
        disabledContractEndDate(end) {
            const start = this.contractBeginning;
            if (start) return compareDesc(end, addDays(start, 1)) > 0;
            else return false;
        },
        template() {
            return _.get(this.data, 'config.template')
        },
        extensions() {
            return _.get(this.template, 'extensions') || []
        },
        ...mapGetters({
            data: 'settings/form',
            options: 'settings/options',
            isSuperUser: 'auth/isSuperUser',
        }),
    },
    methods: {
        addBillingAddress() {
            this.$store.commit('settings/form/addBillingAddress')
        },
        extensionAvailable(extension) {
            return this.extensions.includes(extension)
        },
    },
}
</script>

<style lang="sass" scoped>
.switches
    margin-bottom: 1rem
    & > .el-switch
        margin-bottom: 10px
        &:not(:last-child)
        margin-right: 30px
.switches.shop
    margin-bottom: 12px

.panel
    background: $color-skeleton
    border-radius: 4px
    padding: 0.5rem 1rem
    min-height: 36px
    line-height: 1.3
    .flex-row
        align-items: center
.less-margin
    margin-bottom: 10px
</style>
